/* eslint-disable no-console */
import { onError } from '@apollo/client/link/error';

import { CUSTOM_ERROR_MESSAGES, GRAPHQL_ERROR_CODES } from '@/config/GraphqlErorrCodes.config';

export const customErrorMessageLink = onError(({ forward, operation, graphQLErrors }) => {
  if (!graphQLErrors?.length) {
    return forward(operation);
  }

  graphQLErrors.forEach((graphQLError) => {
    if (!graphQLError.extensions?.code) {
      return undefined;
    }

    const customErrorCodeName = Object.entries(GRAPHQL_ERROR_CODES).find(([, value]) => {
      return value === graphQLError.extensions?.code;
    })?.[0] as keyof typeof CUSTOM_ERROR_MESSAGES | undefined;

    if (customErrorCodeName && CUSTOM_ERROR_MESSAGES[customErrorCodeName]) {
      return CUSTOM_ERROR_MESSAGES[customErrorCodeName];
    }

    return undefined;
  });

  return undefined;
});
